/**
 * How many items arrived at the top of a feed list since it was last seen,
 * judged by where the item that used to be first now sits.
 *
 * Not by how much longer the list got: feeds cap their length (the headline
 * feed keeps 200), so once one is full an arrival adds a row at the top and
 * drops one at the bottom, and the length never changes. Counting by length
 * made every hold-still behaviour switch itself off partway through a session.
 *
 * 0 when the old first item is no longer in the list at all: the list was
 * replaced (a filter change, a new search) rather than added to, so there is
 * no position to hold.
 */
export function countNewAtTop<T>(
  items: readonly T[],
  previousFirst: T | undefined,
  isSameItem: (a: T | undefined, b: T | undefined) => boolean
): number {
  if (previousFirst === undefined) return 0;
  const index = items.findIndex((item) => isSameItem(item, previousFirst));
  return index > 0 ? index : 0;
}
